var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconMemory48Line = function SvgIconMemory48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.3 18.8h-4.6c-1.6 0-2.9 1.3-2.9 2.9v4.6c0 1.6 1.3 2.9 2.9 2.9h4.6c1.6 0 2.9-1.3 2.9-2.9v-4.6c0-1.6-1.3-2.9-2.9-2.9Zm-.5 7h-3.6v-3.6h3.6v3.6Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39 21.7v-3.4h-3.3v-.7c0-2.92-2.38-5.3-5.3-5.3h-.7V9h-3.4v3.3h-4.6V9h-3.4v3.3h-.7a5.31 5.31 0 0 0-5.3 5.3v.7H9v3.4h3.3v4.6H9v3.4h3.3v.7c0 2.92 2.38 5.3 5.3 5.3h.7V39h3.4v-3.3h4.6V39h3.4v-3.3h.7c2.92 0 5.3-2.38 5.3-5.3v-.7H39v-3.4h-3.3v-4.6H39Zm-6.7 8.7a1.9 1.9 0 0 1-1.9 1.9H17.6a1.9 1.9 0 0 1-1.9-1.9V17.6c0-1.05.85-1.9 1.9-1.9h12.8c1.05 0 1.9.85 1.9 1.9v12.8Z",
    fill: "current"
  })));
};
export default SvgIconMemory48Line;